'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function (autosizingService) {
  autosizingService.registerContainerType("asVerticalContainer", function (containerCtrl, $el) {
    var strategy = this;
    strategy.setHeight = function (totalHeight) {
      var components = containerCtrl.getComponents(),
        usedHeight = 0,
        usedPercentage = 0,
        nbAuto = 0;

      // types : auto - fixed - percent
      var processed = [];
      _.each(components, function (component) {
        var componentHeight = component.getRequestedHeight();
        if (/^[0-9]*([.][0-9]*)?px$/.test(componentHeight)) {
          var heightInPixel = parseInt(componentHeight.substring(0, componentHeight.length - 2));
          usedHeight += heightInPixel;
          processed.push({
            component: component,
            type: "fixed",
            height: heightInPixel
          });
        } else if (/^[0-9]*([.][0-9]*)?%$/.test(componentHeight)) {
          var heightInPercent = parseInt(componentHeight.substring(0, componentHeight.length - 1));
          usedPercentage += heightInPercent;
          processed.push({
            component: component,
            type: "percent",
            height: heightInPercent
          });
        } else {
          nbAuto++;
          processed.push({
            component: component,
            type: "auto"
          });
        }
      });
      var availableHeight = totalHeight - usedHeight;
      var availablePercentage = 100 - usedPercentage;
      var heightPerAuto = availablePercentage / nbAuto;

      // console.log("total height : ", totalHeight, processed, heightPerAuto, heightPerAuto * availableHeight / 100);

      _.each(processed, function (proc) {
        if (proc.type === "percent") {
          proc.component.setHeight(parseInt(proc.height * availableHeight / 100));
        } else if (proc.type === "auto") {
          proc.component.setHeight(parseInt(heightPerAuto * availableHeight / 100));
        }
      });
    };
  }, true);
  autosizingService.registerContainerType("asLineContainer", function (containerCtrl, $el) {
    var strategy = this;
    strategy.setHeight = function (totalHeight) {
      var components = containerCtrl.getComponents();
      _.each(components, function (component) {
        component.refreshWidth();
        var componentHeight = component.getRequestedHeight();
        if (/^[0-9]*px$/.test(componentHeight)) {
          //var heightInPixel = parseInt(componentHeight.substring(0, componentHeight.length - 2));
          // nothing ?
        } else if (/^[0-9]*%$/.test(componentHeight)) {
          var heightInPercent = parseInt(componentHeight.substring(0, componentHeight.length - 1));
          component.setHeight(heightInPercent * totalHeight / 100);
        } else {
          component.setHeight(totalHeight);
        }
      });
    };
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/autosizing/containerTypes.js
// module id = 2918
// module chunks = 13